import { useEffect } from 'react';
import { Box } from 'roo-ui/components';
import QFFWidget from 'components/QFFWidget';
import { useDispatch } from 'react-redux';
import { setIsSSOLoginScreenVisible } from 'store/authentication/actions';

const QFFLoginForm = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsSSOLoginScreenVisible(true));
    return () => dispatch(setIsSSOLoginScreenVisible(false));
  }, [dispatch]);

  return (
    <>
      <Box px="15px">Log in with your Frequent Flyer account to view your Qantas Hotels bookings</Box>
      <QFFWidget data-testid="sso-login-form" />
    </>
  );
};

export default QFFLoginForm;
